import { FormLabel } from "@mui/material";
import { Box } from "@mui/material";
import MedTecLogo from "../../../assets/logos/medtec.png";

const Footer = () => {
  return (
    <Box sx={{ pb: 7 }} textAlign="center" pt={2}>
      <img src={MedTecLogo} width={60} /> <br />
      <FormLabel>
        © 2022 MEDTEC Bilgi Teknolojileri ve Yazılım A.Ş. - Tüm Hakları Saklıdır
      </FormLabel>
    </Box>
  );
};
export default Footer;
